import React from "react";
import { Badge } from "@opendate-app/setlist";

const styles = {
  status: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
  },
  domain: {
    fontSize: 16,
    fontWeight: 600,
    color: "var(--sl-text-primary)",
    overflowWrap: "anywhere",
  },
};

const sendDomainBadge = (sendDomain) => {
  if (!sendDomain?.verified) return { color: "error", label: "Unverified" };
  if (!sendDomain.from_address) return { color: "warning", label: "Missing email from address" };
  return { color: "success", label: "Verified" };
};

const SendDomainStatus = ({
  sendDomain
}) => {
  const badge = sendDomainBadge(sendDomain);

  return (
    <div style={styles.status}>
      <span style={styles.domain}>{sendDomain?.domain}</span>
      <Badge color={badge.color} dot>{badge.label}</Badge>
    </div>
  );
};

export default SendDomainStatus;
